// surf_vulcao — T2, 3 stages, mar de LAVA (caiu = morreu). O mapa "caos":
// pushes que te arremessam, escolha de rota e bhop sobre ilhas de lava.
import { Course } from '../course';
import type { GameMap } from '../types';
import { finishMap } from './util';

export function buildVulcao(): GameMap {
  const c = new Course(0, 0, 256, 0);

  // === Stage 1: descida no cânion com push de saída ===
  c.spawnHere(-224);
  const b0 = c.platform(224, 448);
  c.zoneOver(b0, 'start');
  c.drop(544);
  c.ramp(576, 512, 3000);
  c.drop(16);
  c.spawnHere(-224);
  const b1 = c.platform(448, 640);
  c.zoneOver(b1, 'stage', { index: 2 });
  // push no fim da plataforma: te ARREMESSA na direção da próxima rampa
  c.zones.push({
    kind: 'push',
    min: [b1.min[0], b1.min[1], Math.min(b1.min[2], b1.max[2])],
    max: [b1.max[0], b1.max[1] + 96, Math.min(b1.min[2], b1.max[2]) + 96],
    vel: [0, 380, -520],
  });

  // === Stage 2: ESCOLHA de rota — larga e segura vs. estreita e voadora ===
  c.drop(620);
  c.mark();
  c.shift(-560);
  c.ramp(768, 512, 3400);        // rota larga (segura)
  c.restore();
  c.mark();
  c.shift(560);
  c.ramp(384, 512, 2600, 'short'); // rota estreita: acaba antes → voo final
  c.restore();
  c.advance(3400);               // cursor no fim da rota larga, centralizado
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(1152, 640), 'stage', { index: 3 });

  // === Stage 3: bhop nas ilhas de lava + rampa final ===
  c.bhopGaps(6, 224, 352, 256);
  c.drop(544);
  c.ramp(640, 512, 2600);
  c.drop(16);
  c.zoneOver(c.platform(896, 768, 'accent'), 'end');

  return finishMap(c, 'surf_vulcao');
}
